import { enumElementDrawStates, gHelpRef } from "../constants";
import { QStaticText } from "./QStaticText";
import { shadeColor } from "../utils/shadeColor";
import { Globals } from "./Globals.js";

export class QLinkText extends QStaticText {
  constructor() {
    super();
  }

  InitLinkText(theCmd, textColor) {
    this.SetCmdCode(theCmd);
    this.InitStaticText();
    if (textColor == null) Globals._themeMode.text.body;
    this.fHoverColor = Globals._themeMode.text.highlight;
    this.SetTextColor(textColor);
  }

  SetHelpCode(helpCode) {
    if (!gHelpRef[helpCode]) {
      console.log("invalid help code");
      return;
    }
    var langCode = "en";
    this.fHelpCode = helpCode ? langCode + "/" + gHelpRef[helpCode].join("/") : "";
  }

  GetHelpCode() {
    return this.fHelpCode;
  }

  GetParentPanel() {
    return this.fParentPanel;
  }

  SetHoverColor(hoverColor) {
    this.fHoverColor = hoverColor;
  }

  DoRenderElement(drawBuffer) {
    var txtFillStyle = this.GetTextColor();
    var hasCmd = this.GetCmdCode() != null;
    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        txtFillStyle = this.GetTextColor();
        break;
      case enumElementDrawStates.Hover:
        if (hasCmd) txtFillStyle = this.fHoverColor;
        break;
      case enumElementDrawStates.MouseDown:
        if (hasCmd) txtFillStyle = shadeColor(this.fHoverColor, -15);
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }

    this.RenderText(drawBuffer, txtFillStyle);
  }

  GetCursor() {
    return "pointer";
  }
}
